<template>
    <div>
        <Header title="部门管理">
            <template v-slot:content>
                <div style="display: flex">
                    <div style="flex:1">
                    </div>
                    <div>
                        <Button @click="async_d">同步</Button>
                    </div>

                </div>
            </template>
        </Header>
        <div class="my-white-mod">
            <PageTable  :loading="table.loading"  :size="table.limit"   :columns="table.columns" :data="table.data" :current="table.current" :total="table.total" @switchPage="changepage" >
            </PageTable>
        </div>

        <Modal
                :mask-closable="false"
                v-model="show_down"
                :title="up_title"
                width="600">
            <PageTable :loading="down_table.loading" :size="down_table.limit"   :columns="down_table.columns" :data="down_table.data" :current="down_table.current" :total="down_table.total"  @switchPage="changepage" >
            </PageTable>
            <div slot="footer"></div>
        </Modal>
    </div>

</template>
<script>
    import {department_list} from "@/api/system"
    import {sync_department} from "@/api/sync"
    import {Header, PageTable} from "@/components/mainLayout"
    export default {
        components:{
            Header,
            PageTable
        },
        data(){
            return{
                pid:1,
                up_title:"",
                show_down:false,
                table:{
                    loading:false,
                    current:1,
                    total:0,
                    limit:30,
                    columns: [
                        {
                            align:'center',
                            type: 'index'
                        },
                        {
                            title: '部门',
                            align:'center',
                            key: 'name',
                            width:200,
                            render: (h, params) => {
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small'
                                        },
                                        style:{color:'#3F8CFF'},
                                        on: {
                                            click: () => {
                                                this.show_down_department(params.row);

                                            }
                                        }
                                    }, params.row.name)
                                ]);

                            }
                        },
                        {
                            title: '创建时间',
                            align:'center',
                            key: 'ctime'
                        }
                    ],
                    data: []
                },
                down_table:{
                    loading:false,
                    current:1,
                    total:0,
                    limit:30,
                    columns: [
                        {
                            align:'center',
                            type: 'index'
                        },
                        {
                            title: '子部门',
                            align:'center',
                            key: 'name',
                            width:200
                        },
                        {
                            title: '创建时间',
                            align:'center',
                            key: 'ctime'
                        }
                    ],
                    data: []
                }

            }
        },
        mounted(){
            this.list();
        },
        methods:{
            list(){
                this.table.loading = true
                department_list({limit:this.table.limit, page:this.table.current, pid:1}).then(res=>{
                    this.table.loading = false
                    if (res.code == 200) {
                        this.table.data = res.data
                        this.table.total = res.total
                    } else {
                        this.table.data = []
                        this.table.total = 0
                        this.$Message.error(res.msg)
                    }
                })
            },
            changepage(e){
                this.table.current = e;
                this.list();
            },
            async_d(){
                this.$Notice.info({
                    title: '部门数据同步中',
                });
                sync_department().then(res=>{
                    this.$Notice.destroy()
                    if (res.code == 200) {
                        this.$Message.success(res.msg);
                        this.list();
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
            down_list(){
                this.down_table.loading = true;
                department_list({limit:this.down_table.limit, page:this.down_table.current, pid:this.pid}).then(res=>{
                    this.down_table.loading = false
                    if (res.code == 200) {
                        this.down_table.data = res.data
                        this.down_table.total = res.total
                    } else {
                        this.down_table.data = []
                        this.down_table.total = 0
                        this.$Message.error(res.msg)
                    }
                })
            },
            show_down_department(e){
                this.up_title = e.name
                this.show_down = true;
                this.pid = e.id;
                this.down_list()

            }

        }
    }
</script>
